<template>
  <div class="d-flex mx-4">
    <search-autocomplete
      v-model="calc"
      label="PPM Calculator"
      api-path="/api/lots/ppm_calculation_search/"
      :format-entry="x => Object.assign({}, x, { friendlyName: x.name })"
    />
    <base-button
      icon-bool
      styles="mt-4"
      color="error"
      @clicked="$emit('abort')"
      icon="mdi-close-circle-outline"
    />
    <base-button
      icon-bool
      styles="mt-4"
      color="success"
      @clicked="updateLot"
      :loading="updatingLot"
      icon="mdi-plus-circle-outline"
    />
  </div>
</template>

<script>

import SearchAutocomplete from '@/base/components/SearchAutocomplete.vue'

export default {
  name: 'EditPpm',
  components: { SearchAutocomplete },
  props: {
    updatingLot: { type: Boolean, required: true },
    ppmCalc: { type: Object, required: false, default: null }
  },
  data: () => ({
    calc: null
  }),
  methods: {
    updateLot () {
      if (this.calc) {
        let body = { ppm_calculator_id: this.calc.id }
        this.$emit('updateLot', body)
      }
    }
  }
}
</script>
